module.exports = __webpack_public_path__ + "img/loading.81e1aa7b.gif";